"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _services = require("@alycecom/services");

var _gift = require("../../store/gift/gift.selector");

var _constants = require("../../constants");

var _useGiftContext2 = require("../../hooks/useGiftContext");

var _gift2 = require("../../store/gift/gift.actions");

var _invitationType = require("../../store/gift/invitationType");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    button: {
      color: palette.common.white,
      backgroundColor: palette.red.main,
      '&:hover': {
        backgroundColor: palette.red.main
      }
    }
  };
});
var useModalStyles = (0, _styles.makeStyles)(function (_ref2) {
  var spacing = _ref2.spacing,
      palette = _ref2.palette;
  return {
    avatar: {
      backgroundColor: palette.error.main
    },
    root: {
      borderTop: "4px solid ".concat(palette.error.main)
    },
    submitButton: {
      backgroundColor: palette.error.main,
      paddingLeft: spacing(1),
      paddingRight: spacing(1),
      width: 156
    },
    cancelButton: {
      paddingLeft: spacing(1),
      paddingRight: spacing(1),
      width: 110
    },
    actions: {
      justifyContent: 'flex-end'
    }
  };
});
var Modals;

(function (Modals) {
  Modals["None"] = "none";
  Modals["Expire"] = "expire";
  Modals["Unexpire"] = "unexpire";
  Modals["Cancel"] = "cancel";
})(Modals || (Modals = {}));

var SentGiftExpireAction = function SentGiftExpireAction() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var classes = useStyles();
  var modalClasses = useModalStyles();

  var _useState = (0, _react.useState)(Modals.None),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      confirmationModal = _useState2[0],
      setConfirmationModal = _useState2[1];

  var isLoading = (0, _reactRedux.useSelector)(_gift.getGiftIsLoading);
  var statusId = (0, _reactRedux.useSelector)(_gift.getGiftStatusId);
  var isDirectDelivery = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      _useGiftContext$sideb = _useGiftContext.sidebarMode,
      sidebarMode = _useGiftContext$sideb === void 0 ? false : _useGiftContext$sideb,
      _useGiftContext$conta = _useGiftContext.contact;

  _useGiftContext$conta = _useGiftContext$conta === void 0 ? {} : _useGiftContext$conta;
  var _useGiftContext$conta2 = _useGiftContext$conta.firstName,
      contactFirstName = _useGiftContext$conta2 === void 0 ? '' : _useGiftContext$conta2;

  var _ref3 = (0, _reactRedux.useSelector)(_gift.getGiftOriginalSender) || {},
      _ref3$id = _ref3.id,
      senderId = _ref3$id === void 0 ? null : _ref3$id;

  var isCanBeExpired = [_constants.giftStatuses.GIFT_EMAIL_SENT, _constants.giftStatuses.GIFT_ACCESSED].includes(statusId) && !isLoading && !isDirectDelivery;
  var isCanBeUnexpired = statusId === _constants.giftStatuses.EXPIRED && !isLoading && !isDirectDelivery;
  var isCanBeCanceled = statusId === _constants.giftStatuses.SCHEDULED && !isLoading;
  var confirmModalsStyles = sidebarMode ? {
    width: 600
  } : {
    top: 0,
    width: '100%'
  };
  var handleShowModal = (0, _react.useCallback)(function (event) {
    var modal = event.currentTarget.dataset.modal;

    if (modal) {
      setConfirmationModal(modal);
    }
  }, []);
  var handleCloseModal = (0, _react.useCallback)(function () {
    setConfirmationModal(Modals.None);
  }, []);
  var handleExpireConfirm = (0, _react.useCallback)(function () {
    dispatch((0, _gift2.giftExpireRequest)(giftId));
    trackEvent('Gifting flow - expire gift', {
      gift_id: giftId,
      sender_id: senderId
    });
    setConfirmationModal(Modals.None);
  }, [dispatch, trackEvent, giftId, senderId]);
  var handleUnexpireConfirm = (0, _react.useCallback)(function () {
    dispatch(_gift2.giftUnexpire.pending());
    trackEvent('Gifting flow - unexpire gift', {
      gift_id: giftId,
      sender_id: senderId
    });
    setConfirmationModal(Modals.None);
  }, [dispatch, trackEvent, giftId, senderId]);
  var handleCancelConfirm = (0, _react.useCallback)(function () {
    dispatch((0, _gift2.giftCancelRequest)(giftId));
    setConfirmationModal(Modals.None);
  }, [dispatch, giftId]);

  if (isCanBeUnexpired) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
      my: 1,
      ml: 3.5
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      "data-modal": Modals.Unexpire,
      className: classes.button,
      variant: "contained",
      disabled: isLoading,
      onClick: handleShowModal
    }, "Unexpire this gift")), /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, (0, _extends2.default)({
      title: "Unexpire gift?",
      icon: "exclamation-triangle",
      variant: "warning",
      customClasses: modalClasses,
      submitButtonText: "Unexpire",
      cancelButtonText: "Cancel",
      isOpen: Modals.Unexpire === confirmationModal,
      onSubmit: handleUnexpireConfirm,
      onDiscard: handleCloseModal
    }, confirmModalsStyles), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "Body-Regular-Left-Static"
    }, "Do you really want to Unexpire this gift?")));
  }

  if (isCanBeExpired) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
      my: 1,
      ml: 3.5
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      "data-modal": Modals.Expire,
      className: classes.button,
      variant: "contained",
      disabled: isLoading,
      onClick: handleShowModal
    }, "Expire this gift")), /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, (0, _extends2.default)({
      title: "Expire gift?",
      icon: "exclamation-triangle",
      variant: "warning",
      customClasses: modalClasses,
      submitButtonText: "Expire",
      cancelButtonText: "Cancel",
      isOpen: Modals.Expire === confirmationModal,
      onSubmit: handleExpireConfirm,
      onDiscard: handleCloseModal
    }, confirmModalsStyles), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "Body-Regular-Left-Static"
    }, "By doing so, ", contactFirstName, " won't be able to access this gift. ", contactFirstName, "'s information and research will be saved though!")));
  }

  if (isCanBeCanceled) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
      my: 1,
      ml: 3.5
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      "data-modal": Modals.Cancel,
      className: classes.button,
      variant: "contained",
      disabled: isLoading,
      onClick: handleShowModal
    }, "Cancel this gift")), /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, (0, _extends2.default)({
      title: "Cancel gift?",
      icon: "exclamation-triangle",
      variant: "warning",
      customClasses: modalClasses,
      submitButtonText: "Confirm",
      cancelButtonText: "Cancel",
      isOpen: Modals.Cancel === confirmationModal,
      onSubmit: handleCancelConfirm,
      onDiscard: handleCloseModal
    }, confirmModalsStyles), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "Body-Regular-Left-Static"
    }, "By doing so, ", contactFirstName, " won't be able to access this gift. ", contactFirstName, "'s information and research will be saved though!")));
  }

  return null;
};

var _default = /*#__PURE__*/(0, _react.memo)(SentGiftExpireAction);

exports.default = _default;